import React from 'react';
import Header from '../components/Header';
import LogoHeader from "../components/LogoHeader";
import i18n from 'i18next';

const NotAllowIP = ({ message = i18n.t('MSG_GLOBAL_NOT_ALLOW_IP_ERROR')}: any) => {
    return (
        <div className='static md:fixed md:inset-0'>
            <div className='min-w-[100%] md:min-w-[30.625rem] static md:absolute md:top-[141px] left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
                <LogoHeader page="advanced"></LogoHeader>
                <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[30.625rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-[24px] md:px-[24px] whitespace-pre-wrap text-center'>
                    <div className="hidden md:block">
                        <Header title={message} customStyle="!inline-flex"></Header>
                    </div>
                    <div className="block md:hidden">
                        <Header title=""></Header>
                        <div className="w-full mt-[3.125rem] md:mt-0 px-4 md:px-0">
                            <p className='mb-6 text-base font-bold alu-text-base-2'>{message}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotAllowIP;
